import React, { ReactNode } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

interface GoogleMapsProviderProps {
  apiKey: string;
  children: (isLoaded: boolean) => ReactNode;
}

const GOOGLE_MAPS_LIBRARIES: (
  | "places"
  | "geometry"
  | "drawing"
  | "visualization"
)[] = ["places", "visualization", "drawing"]; // ✅ Includes "places" for Autocomplete

const GoogleMapProvider: React.FC<GoogleMapsProviderProps> = ({
  apiKey,
  children,
}) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: apiKey,
    libraries: GOOGLE_MAPS_LIBRARIES, // ✅ Loads all libraries once
  });

  if (loadError) {
    console.error("❌ Google Maps API failed to load.");
  }

  return <>{children(isLoaded)}</>; // ✅ Ensures only `isLoaded` is passed to children
};

export default GoogleMapProvider;
